import { useMediaQuery, useTheme } from '@mui/material';

// Phone breakpoint (<600px). MUI v4 `down('sm')` is <960px and must not be used here.
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return !useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
};

export const useIsCoarsePointer = (): boolean => useMediaQuery('(hover: none) and (pointer: coarse)', { noSsr: true });
